module.exports = __webpack_public_path__ + "static/media/ic_checkup.6c73e220.svg";